<template>
  <div class="product-card" @click="$emit('click', product)">
    <div class="product-image">
      <div class="image-flipper" :class="{ 'has-back': !!backImage }">
        <div class="image-front">
          <img v-if="product.image" :src="product.image" :alt="product.nameCn" />
          <div v-else class="placeholder-img">{{ product.brand }}</div>
        </div>
        <div v-if="backImage" class="image-back">
          <img :src="backImage" :alt="product.nameCn" />
        </div>
      </div>
      <span v-if="product.tag" class="product-tag">{{ product.tag }}</span>

    </div>
    <div class="product-info">
      <p class="product-brand">{{ product.brand }}</p>
      <p class="product-name">{{ product.name }}</p>
      <p class="product-name-cn">{{ product.nameCn }}</p>
      <p class="product-spec">{{ product.spec }}</p>
      <div class="product-price" :style="{ opacity: product.soldOut ? 0 : 1 }">
        <span class="price-current">${{ product.price }}</span>
        <span v-if="product.originalPrice" class="price-original">${{ product.originalPrice }}</span>
      </div>
      <button
        class="add-cart-text-btn"
        :class="{ disabled: product.soldOut }"
        :disabled="product.soldOut"
        @click.stop="!product.soldOut && $emit('add-cart', product)"
      >
        {{ product.soldOut ? $t('common.sold_out') : $t('common.add_to_cart') }}
      </button>
      <!-- <slot name="actions">
        <button v-if="!product.soldOut" class="add-cart-btn" @click.stop="$emit('add-cart', product)">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"/>
            <line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
        </button>
        <span v-if="product.soldOut" class="sold-out-badge">{{ $t('common.sold_out') }}</span>
      </slot> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({
        brand: '',
        name: '',
        nameCn: '',
        spec: '',
        price: '0',
        originalPrice: null,
        image: null,
        tag: null
      })
    }
  },
  computed: {
    backImage() {
      const p = this.product
      if (typeof p.images === 'string' && p.images.trim()) {
        const first = p.images.split(',')[0].trim()
        if (first) {
          const BASE_URL = process.env.VUE_APP_API_BASE_URL || ''
          return first.startsWith('http') ? first : `${BASE_URL}${first}`
        }
      }
      if (Array.isArray(p.gallery) && p.gallery.length) {
        return p.gallery[0]
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.product-card {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.3s;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translate(5px,-4px);
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.3);
  }

  &:hover .image-flipper.has-back {
    .image-front {
      opacity: 0;
    }
    .image-back {
      opacity: 1;
    }
  }
}

.product-image {
  position: relative;
  background: #f7f7f7;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 375px;
  flex-shrink: 0;
  overflow: hidden;

  .image-flipper {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .image-front,
  .image-back {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.5s ease-in-out;
  }

  .image-front {
    opacity: 1;
  }

  .image-back {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.placeholder-img {
  width: 100%;
  height: 180px;
  background: linear-gradient(135deg, #e8e8e8 0%, #d0d0d0 100%);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #666;
  font-weight: bold;
}

.product-tag {
  position: absolute;
  top: 8px;
  left: 8px;
  background: #d4af37;
  color: #1a1a1a;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: bold;
  border-radius: 2px;
}

.sold-out-badge {
  position: absolute;
  bottom: 12px;
  right: 12px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 12px;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;text-align: center;
}

.product-info {
  padding: 12px 16px 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.product-brand {
  font-size: 12px;
  color: #d4af37;
  margin-bottom: 4px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.product-name {
  font-size: 12px;
  color: #888;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-name-cn {
  font-size: 14px;
  color: #333;
  margin-bottom: 6px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-spec {
  font-size: 12px;
  color: #999;
  margin-bottom: 10px;
}

.add-cart-btn {
  position: absolute;
  bottom: 12px;
  right: 12px;
  width: 35px;
  height: 35px;
  background: #987701;
  color: #fff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  &:hover {
    background: #b9aa6b;
    transform: scale(1.1);
  }

  svg {
    width: 14px;
    height: 14px;
  }
}

.product-price {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 10px;
}

.add-cart-text-btn {
  width: 100%;
  padding: 8px 0;
  background: linear-gradient(90deg, #5e5e5e 0%, #333333 100%);
  color: #fff;
  border: none;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  letter-spacing: 1px;
  margin-top: auto;

  &:hover {
    background: linear-gradient(164deg, #8b8a73 0%, #575448 100%);
  }

  &.disabled {
    background: #ccc;
    color: #999;
    cursor: not-allowed;

    &:hover {
      background: #ccc;
    }
  }
}

.price-current {
  font-size: 18px;
  color: #d4af37;
  font-weight: bold;
}

.price-original {
  font-size: 13px;
  color: #bbb;
  text-decoration: line-through;
}
@media (max-width:768px) {
  .product-image {
    height: 200px;
    img {
      height: 200px;
    }
  }
}
</style>
